import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIcon } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

import { BaseSecondaryCtaComponent } from '../base-secondary-cta.component';

@Component({
    selector: 'st-cast-secondary-cta',
    imports: [MatButtonModule, MatButtonToggleModule, MatIcon, MatListModule, MatMenuModule, MatTooltipModule],
    templateUrl: './cast-secondary-cta.component.html',
    styleUrl: './cast-secondary-cta.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-cast-secondary-cta',
    },
})
export class CastSecondaryCtaComponent extends BaseSecondaryCtaComponent {}
